import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { LazyTeamCalendars, CALENDAR_CONTEXT } from '@confluence/team-calendar';

export const SpaceEmbeddedSubcalendarRoute: {
	({ params: { subCalendarId } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey, subCalendarId } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
				attributes: {
					subCalendarId: string;
				};
			};
			pageState: {
				spaceKey: string;
			};
		};
		MainLayout: {
			enableNavigation: boolean;
			spaceKey: string;
		};
	};
} = ({ params: { subCalendarId } }: RouteMatch): React.JSX.Element => {
	return (
		<LazyTeamCalendars
			calendarContext={CALENDAR_CONTEXT.EMBEDDED_SUBCALENDAR}
			subCalendarId={subCalendarId}
		/>
	);
};

SpaceEmbeddedSubcalendarRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey, subCalendarId },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
			attributes: {
				subCalendarId: string;
			};
		};
		pageState: {
			spaceKey: string;
		};
	};
	MainLayout: {
		enableNavigation: boolean;
		spaceKey: string;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'spaceEmbeddedSubcalendarScreen',
			id: spaceKey,
			attributes: {
				subCalendarId,
			},
		},
		pageState: { spaceKey },
	},
	MainLayout: {
		enableNavigation: false,
		spaceKey,
	},
});
